/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setFixed.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * クイズに答えるボタン
 */
const fixedTargets = document.getElementById("js-fixed-target");
const contentsMain = document.getElementById("lp-header");

const setFixed = () => {
  let mainVH = contentsMain.clientHeight;
  if (window.pageYOffset > mainVH / 1.5) {
    fixedTargets.style.opacity = "1";
  } else if (window.pageYOffset < mainVH) {
    fixedTargets.style.opacity = "0";
  }
};

window.addEventListener("scroll", setFixed);

export { setFixed };
